export const GUARDAR_INSCRIPCIONES_GRAFICA =
  "[DASHBOARD-INSCRIPCIONES] GUARDA LAS INSCRIPCIONES PARA GENERAR GRÁFICAS";
export function guardarInscripcionesGrafica(inscripciones) {
  return (dispatch) => {
    dispatch({ type: GUARDAR_INSCRIPCIONES_GRAFICA, payload: inscripciones });
  };
}
